import { useEffect, useState, useRef } from "react";
import opCodes from '../../constants/opCodes.jsx';
import GamePhaser from "./components/GamePhaser";
import "./Game.css";
import { Button, Image, Modal, Offcanvas, CloseButton, Row, Col, Navbar, Container, Toast, ToastContainer } from "react-bootstrap"
import { user, client, session, socketConnected, socket } from "../../utils/nakama";
import { playSound, handleClickSound } from "../game/scenes/classes/PlaySound";
import LandscapeModal from "../../components/LandscapeModal.jsx";
import LeaveGameModal from "../../components/LeaveGameModal.jsx";
import bonezIcon from '../../assets/images/bonez_icon.svg'
import lose_icon from '../../assets/images/lose_icon.svg'
import win_trophy from '../../assets/images/win_trophy.svg'
import fire_icon from '../../assets/images/fire_icon.png'
import xpIcon from '../../assets/images/xp.png'
import settingsIcon from '../../assets/images/settings_icon.png'
import infoIcon from '../../assets/images/info_icon.png'
// import vipIcon from '../../assets/images/gold_vip_icon.png'
import firstTimeImage from '../../assets/images/lobby_help_info.webp'
import leaveGameButton from '../../assets/images/leave_game_button.png'
import PlayerInfo from '../lobby/components/PlayerInfo.jsx'
import InfoNav from "../lobby/components/InfoNav.jsx";
import PlayerChat from "../lobby/components/PlayerChat.jsx";
import './Game.css'
import eventsCenter, { PHASER_EVENTS } from "../../utils/phaserEvents.js";
// import {leaveModalValue} from "./scenes/BonezGame.js";
import tieBackground from '../../assets/images/tie_bg.png'

const loseSound = new Audio('/bonez/sounds/you_lose.mp3');
// Vite replacement for require.context on public assets
const cardImages = (path) => {
    // Remove ./ from the beginning if present
    const cleanPath = path.startsWith('./') ? path.substring(2) : path;
    return `/bonez/images/cards/${cleanPath}`;
};

//These exports become available on phaser
export let displayResurrectModal = { value: false, cardIndex: null };

export let gameData = null;
export let emojiData = null;
export let matchIdGame = null;
export let isSpectator = false; //set to true if user is a spectator
export let leaveGameSpectator = { value: false }; //set to true if user is a spectator and wants to return to lobby
export let playerBonezMatchData = null;

let disconnectTimer = 0; //seconds

export default function Game({ matchId, setCurrentScreen, opCodeData, setOpCodeData }) {
    matchIdGame = matchId;
    const [userLevels, setUserLevels] = useState();
    const [zoomBalance, setZoomBalance] = useState();
    const [gameRef, setGameRef] = useState(null); //this value is changed by the GamePhaser.jsx component (child)

    //op code listener
    // const [gameData, setGameData] = useState(null);
    //const [showWaitingMatchStartModal, setShowWaitingMatchStartModal] = useState(false);
    const [showWinModal, setShowWinModal] = useState(false);
    const [showLoseModal, setShowLoseModal] = useState(false);
    const [showWinModalSpectator, setShowWinModalSpectator] = useState(false);
    const [showDisconnectModal, setShowDisconnectModal] = useState(false);
    const [showDisconnectModalSpectator, setShowDisconnectModalSpectator] = useState(false);
    const [isShowingLandscapeModal, setIsShowingLandscapeModal] = useState(false);

    const [showTieModal, setShowTieModal] = useState(false);
    const [showLeaveGameModal, setShowLeaveGameModal] = useState(false);

    const [playerWinStreak, setPlayerWinStreak] = useState(0);
    const [opponentWinStreak, setOpponentWinStreak] = useState(0);
    const timeoutRef = useRef(null);

    const sidebarRef = useRef(null);
    const settingsButtonRef = useRef(null);
    const infoButtonRef = useRef(null);

    const [isSettingsBarActive, setIsSettingsBarActive] = useState(false);
    const [isInfoBarActive, setIsInfoBarActive] = useState(false);

    const [isPlayerInfonav, setIsPlayerInfonav] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [username, setUsername] = useState(null);

    // Tournament and Match Result Toasts
    const [showTournamentToast, setShowTournamentToast] = useState(false);
    const [tournamentEndedText, setTournamentEndedText] = useState("Loading..");
    const [showMatchResultToast, setShowMatchResultToast] = useState(false);
    const [matchResultText, setMatchResultText] = useState("");

    const [playerChatOpen, setPlayerChatOpen] = useState(false);


    const [showFirstTimeModal, setShowFirstTimeModal] = useState(false);

    const LOCAL_STORAGE_MUSIC_VOLUME = 'musicVolume';
    const LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

    // fetching values from local storage or use default values
    const musicVolumeFromStorage = localStorage.getItem(LOCAL_STORAGE_MUSIC_VOLUME);
    const soundVolumeFromStorage = localStorage.getItem(LOCAL_STORAGE_SOUND_VOLUME);

    const initialMusicVolume = musicVolumeFromStorage !== null ? +musicVolumeFromStorage : 12.5;
    const initialSoundVolume = soundVolumeFromStorage !== null ? +soundVolumeFromStorage : 12.5;

    const [musicVolume, setMusicVolume] = useState(initialMusicVolume);
    const [soundVolume, setSoundVolume] = useState(initialSoundVolume);

    const musicSliderBackground = {
        background: `linear-gradient(90deg, #00D1FF 0%, #00D1FF ${musicVolume}%, #5A4F71 ${musicVolume}%, #5A4F71 100%)`
    };
    const soundSliderBackground = {
        background: `linear-gradient(90deg, #00D1FF 0%, #00D1FF ${soundVolume}%, #5A4F71 ${soundVolume}%, #5A4F71 100%)`
    };

    const closeModal = () => {
        setShowLeaveGameModal(false);
    }

    const togglePlayerChat = () => {
        console.log("Toggling player chat", playerChatOpen);
        setPlayerChatOpen(!playerChatOpen);
    };

    useEffect(() => {
        const musicElements = document.querySelectorAll(".music");
        const soundElements = document.querySelectorAll(".sound-fx");

        musicElements.forEach(element => {
            element.volume = musicVolume / 100;
        });

        soundElements.forEach(element => {
            element.volume = soundVolume / 100;
        });
    }, [musicVolume, soundVolume]);

    // Update local storage when volumes change
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_MUSIC_VOLUME, musicVolume);
        localStorage.setItem(LOCAL_STORAGE_SOUND_VOLUME, soundVolume);
    }, [musicVolume, soundVolume]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && !settingsButtonRef.current.contains(event.target)) {
                setIsSettingsBarActive(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sidebarRef]);

    useEffect(() => {
        if (window.innerHeight > window.innerWidth) {
            setIsShowingLandscapeModal(true)
        } else {
            setIsShowingLandscapeModal(false)
        }
    }, [window.innerHeight, window.innerWidth])

    useEffect(() => {
        eventsCenter.on(PHASER_EVENTS.BONE_COLLECTED, (notification) => {
            const getUserName = async (retryCount = 0) => {
                const maxRetries = 2;
                const retryDelay = 1000 * (retryCount + 1);

                try {
                    const userData = await client.getUsers(session, [notification.sender_id]);
                    setUsername(userData.users[0].username);
                    //Show Toast
                    setShowToast(true);
                } catch (error) {
                    console.error("Error getting username for bone collection:", error);

                    // Retry on server errors (500) but not on authentication errors
                    if (retryCount < maxRetries &&
                        (error.message?.includes('500') || error.message?.includes('Internal Server Error'))) {
                        console.log(`Retrying getUsers for username in ${retryDelay}ms... (attempt ${retryCount + 1}/${maxRetries})`);
                        setTimeout(() => getUserName(retryCount + 1), retryDelay);
                        return;
                    }

                    // Show toast with fallback username
                    setUsername("Unknown Player");
                    setShowToast(true);
                }
            }
            getUserName();
        });

        // Tournament Update Event Listener
        eventsCenter.on(PHASER_EVENTS.TOURNAMENT_UPDATE, (payload) => {
            setTournamentEndedText(payload.subject);
            setShowTournamentToast(true);
        });

        // Match Result Event Listener
        eventsCenter.on(PHASER_EVENTS.MATCH_RESULT, (payload) => {
            // Store the content components separately
            const resultData = {
                subject: payload.subject,
                potWin: payload.content.potWin,
                type: payload.content.type,
                // This will be used to determine whether to show emoji or image
                isChipz: payload.content.type !== "bone"
            };
            setMatchResultText(resultData);
            setShowMatchResultToast(true);
        });

        async function getUserInfo() {
            if (user && user.metadata) {
                const objects = await client.readStorageObjects(session, {
                    "object_ids": [{
                        "collection": "user_levels",
                        "key": "user_levels",
                        "user_id": session.user_id
                    }]
                })
                setUserLevels(objects.objects[0].value.data);

                var account = await client.getAccount(session);
                setZoomBalance(parseInt(JSON.parse(account.wallet).zoom));
            }
        }
        getUserInfo();
        const checkAndSetLocalStorage = () => {
            if (!localStorage.getItem('bonez-first-time')) {
                localStorage.setItem('bonez-first-time', true);
                //show tutorial modal
                setShowFirstTimeModal(true);
            } else {
                if (localStorage.getItem('bonez-first-time') === 'true') {
                    setShowFirstTimeModal(true);
                } else {
                    setShowFirstTimeModal(false);
                }
            }
        };
        checkAndSetLocalStorage();
    }, []);

    useEffect(() => {
        async function handleOpCodeData() {
            if (opCodeData) {
                //if no server ping in 15 seconds, return to lobby


                // -----------------------> Uncommneted to test to leave the screen to game (loser modal remain)
                // clearTimeout(timeoutRef.current);
                // timeoutRef.current = setTimeout(() => {
                //     clearTimeout(timeoutRef.current);
                //     gameData = null;
                //     setOpCodeData(null);
                //     setCurrentScreen("game");
                // }, 15000);

                const decodedData = JSON.parse(new TextDecoder().decode(opCodeData.data));
                //console.log("decodedData", decodedData);
                switch (opCodeData.op_code) {
                    case opCodes.gameData: {
                        isSpectator = false;
                        gameData = decodedData;
                        setShowDisconnectModal(false);
                        setShowDisconnectModalSpectator(false);

                        if (decodedData.playerWins === 3) {
                            await socket.leaveMatch(matchId);
                            window.Phaser.PlayerInfo = false;
                            window.Phaser.MyInfo = false;
                            // setShowWinModal(true);
                        }
                        else if (decodedData.opponentWins === 3) {
                            window.Phaser.PlayerInfo = false;
                            window.Phaser.MyInfo = false;
                            setShowLoseModal(true);
                            loseSound.play();

                        }

                        // hiding modal when turn timer starts again (30 is too fast)
                        if (decodedData.turnTimer < 19 &&
                            (decodedData.playerCardsOnField.length > 0 || decodedData.opponentCardsOnField.length > 0)) {
                            setShowTieModal(false);
                        }

                        break;
                    }
                    case opCodes.gameDataSpectator: {
                        isSpectator = true;
                        gameData = decodedData;
                        setShowDisconnectModal(false);
                        setShowDisconnectModalSpectator(false);
                        if (decodedData.playerWins === 3) {
                            window.Phaser.PlayerInfo = false;
                            window.Phaser.MyInfo = false;
                            setShowWinModal(true)
                        }
                        else if (decodedData.opponentWins === 3) {
                            window.Phaser.PlayerInfo = false;
                            window.Phaser.MyInfo = false;
                            setShowLoseModal(true);
                        }
                        if (decodedData.turnTimer < 19 &&
                            (decodedData.playerCardsOnField.length > 0 || decodedData.opponentCardsOnField.length > 0)) {
                            setShowTieModal(false);
                        }
                        break;
                    }
                    case opCodes.serverSendEmojiData: {
                        if (gameData && !isSpectator) {
                            emojiData = {
                                playerSentEmojis: decodedData.player.sentEmojis,
                                opponentSentEmojis: decodedData.opponent.sentEmojis
                            }
                        }
                        else if (gameData && isSpectator) {
                            emojiData = {
                                playerSentEmojis: decodedData.player.sentEmojis,
                                opponentSentEmojis: decodedData.opponent.sentEmojis,
                                spectatorSentEmojis: decodedData.spectatorsEmojis
                            }
                        }
                        else {
                            gameData = decodedData;
                        }
                        break;
                    }
                    case opCodes.spectatorSendEmojiData: {
                        if (gameData && isSpectator) {
                            emojiData = {
                                spectatorSentEmojis: decodedData.spectatorsEmojis
                            }
                        }
                        else {
                            gameData = decodedData;
                        }
                        break;
                    }

                    case opCodes.waitingMatchStart: {
                        isSpectator = false;
                        gameData = decodedData
                        //setShowWaitingMatchStartModal(true);
                        break;
                    }
                    case opCodes.waitingMatchStartSpectator: {
                        isSpectator = true;
                        gameData = decodedData
                        //setShowWaitingMatchStartModal(true);
                        break;
                    }
                    // case opCodes.updateTurnTimer: {
                    //     setShowDisconnectModal(false);
                    //     setShowDisconnectModalSpectator(false);
                    //     if (gameData) {
                    //         gameData.turnTimer = decodedData.turnTimer;
                    //     }
                    //     break;
                    // }
                    case opCodes.tieRound: {
                        setShowTieModal(true);
                        setShowDisconnectModal(false);
                        setShowDisconnectModalSpectator(false);
                        decodedData.isTie = true;
                        gameData = decodedData;
                        break;
                    }
                    case opCodes.opponentDisconnected: {
                        gameData = decodedData;
                        // Safely set disconnectTimer with fallback to 0
                        const timerValue = decodedData.playerRejoinTimer;
                        disconnectTimer = (timerValue && !isNaN(timerValue) && timerValue > 0) ? timerValue : 0;
                        if (!isSpectator) {
                            setShowDisconnectModal(true);
                        }
                        else {
                            setShowDisconnectModalSpectator(true);
                        }
                        break;
                    }
                    case opCodes.opponentReconnected: {
                        console.log("opponent reconnected (Game)");
                        gameData = decodedData;
                        setShowDisconnectModal(false);
                        setShowDisconnectModalSpectator(false);
                        break;
                    }
                    case opCodes.playerDisconnected: { //spectators only
                        console.log("disconnect timer updated (Game)");
                        gameData = decodedData;
                        // Safely set disconnectTimer with fallback to 0
                        const timerValue = decodedData.playerRejoinTimer;
                        disconnectTimer = (timerValue && !isNaN(timerValue) && timerValue > 0) ? timerValue : 0;
                        setShowDisconnectModalSpectator(true);
                        break;
                    }
                    case opCodes.playerReconnected: { //spectators only
                        console.log("player reconnected (Game)");
                        gameData = decodedData;
                        setShowDisconnectModal(false);
                        setShowDisconnectModalSpectator(false);
                        break;
                    }
                    case opCodes.matchStartPlayer1: {
                        if (isSpectator) {
                            socket.leaveMatch(matchId);
                            timeoutRef.current = setTimeout(() => {
                                setCurrentScreen("deckBuilder");
                            }, 2500);
                            leaveGameSpectator.value = false;
                            setOpCodeData(null); //prevent immediate rejoin
                            clearTimeout(timeoutRef.current);
                        }
                        break;
                    }
                    case opCodes.matchStartPlayer2: {
                        if (isSpectator) {
                            socket.leaveMatch(matchId);
                            timeoutRef.current = setTimeout(() => {
                                setCurrentScreen("deckBuilder");
                            }, 2500);
                            leaveGameSpectator.value = false;
                            setOpCodeData(null); //prevent immediate rejoin
                            clearTimeout(timeoutRef.current);
                        }
                        break;
                    }
                    default: {
                        console.log("Unknown op code (Game): ", opCodeData.op_code);
                    }
                }
            }
        }
        handleOpCodeData();
    }, [opCodeData]);

    // bonez match storage fetch
    useEffect(() => {
        async function fetchData() {
            playerBonezMatchData = await getPlayerStorage();
            setPlayerWinStreak(playerBonezMatchData.winStreak);
        }
        fetchData();
    }, []);

    useEffect(() => {
        async function fetchData() {
            const streak = await getOpponentStorage();
            setOpponentWinStreak(streak);
        }
        fetchData();
    }, []);

    useEffect(() => {
        async function PlayerInfo() {
            if (window.Phaser.PlayerInfo || window.Phaser.MyInfo || window.Phaser.SpectatorInfo) {
                setIsPlayerInfonav(true);
            }
        } PlayerInfo();
    }, [window.Phaser.PlayerInfo, window.Phaser.MyInfo, window.Phaser.SpectatorInfo]);

    useEffect(() => {
        async function PlayerChat() {
            if (window.Phaser.showPlayerChat) {
                console.log("Player Chat Opened");
                window.Phaser.showPlayerChat = false;
                setPlayerChatOpen(true);

            }
        } PlayerChat();
    }, [window.Phaser.showPlayerChat]);

    async function getPlayerStorage() {
        //console.log('GAME DATA', gameData);

        const objects = await client.readStorageObjects(session, {
            "object_ids": [{
                "collection": "bonez_matches",
                "key": "bonez_matches",
                "user_id": gameData.player.userId
            },]

        });
        //console.log('PLAYER WINSTREAK', objects.objects[0].value.data.winStreak);
        return objects.objects[0].value.data;
    }

    async function getOpponentStorage() {
        const objects = await client.readStorageObjects(session, {
            "object_ids": [{
                "collection": "bonez_matches",
                "key": "bonez_matches",
                "user_id": gameData.opponent.userId
            }]
        });
        //console.log('OPPONENT WINSTREAK',objects.objects[0].value.data.winStreak);
        return objects.objects[0].value.data.winStreak;
    }

    //check if spectator wants to leave game
    useEffect(() => {
        async function leaveMatch() {
            if (socketConnected && matchId !== "") {
                await socket.leaveMatch(matchId);
                console.log("Left match as spectator: ", matchId);
            }
            leaveGameSpectator.value = false;
            setOpCodeData(null); //prevent immediate rejoin
            clearTimeout(timeoutRef.current);
            setCurrentScreen("lobby");
        }

        if (leaveGameSpectator.value === true) {
            leaveMatch();
        }
    }, [leaveGameSpectator.value]);

    //change canvas container size based on screen dimensions
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    useEffect(() => {
        function handleWindowResize() {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        }

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        }
    }, []);

    const hideFirstTimeForever = () => {
        console.log("Hiding first time modal forever");
        setShowFirstTimeModal(false);
        localStorage.setItem('bonez-first-time', false);
    }

    useEffect(() => {
        const onSocketReconnected = () => {
            // Handle successful reconnection
            setShowDisconnectModal(false);
            // Potentially refresh game state
        };

        const onConnectionFailed = () => {
            // Handle permanent connection failure
            setShowDisconnectModal(true);
            // Maybe show a "returning to lobby" message
        };

        eventsCenter.on(PHASER_EVENTS.SOCKET_RECONNECTED, onSocketReconnected);
        eventsCenter.on(PHASER_EVENTS.CONNECTION_FAILED, onConnectionFailed);

        return () => {
            eventsCenter.off(PHASER_EVENTS.SOCKET_RECONNECTED, onSocketReconnected);
            eventsCenter.off(PHASER_EVENTS.CONNECTION_FAILED, onConnectionFailed);
        };
    }, []);

    return (

        <div id="phaser-container" className="game-container" style={{ width: screenWidth, height: screenHeight }}>
            <audio id="clickSound" class="sound-fx" hidden>
                <source src="/bonez/sounds/click.mp3" type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>
            <Modal show={isShowingLandscapeModal} centered>
                <LandscapeModal />
            </Modal>
            <Modal
                show={showFirstTimeModal}
                fullscreen="true"
                size="xl"
                data-bs-theme="dark"
                onHide={() => setShowFirstTimeModal(false)}
                // dialogClassName="first-time-modal"
                centered
                dialogClassName="first-time-modal"
            >
                <Modal.Body>
                    <Image src={firstTimeImage} alt="First time modal" fluid></Image>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" size="lg" onClick={() => hideFirstTimeForever()}>Never Show again</Button>
                    <Button variant="primary" size="lg" onClick={() => setShowFirstTimeModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>

            <Navbar className="taskbar" style={{ marginBottom: '-6%', height: '10%' }}>
                <Container fluid style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                    <Row className="flex-nowrap" style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <Col xs="auto" sm="2" lg="auto" xl="3" xxl="auto" style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                className="icon-chipz"
                                title="Zoombies Chipz"
                                src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                alt="Chipz icon"
                            />
                            <span className="container-body-text chipz-amount" style={{ color: "#00D1FF", marginLeft: "5%" }}>
                                {zoomBalance && zoomBalance.toLocaleString()}
                            </span>
                        </Col>
                        <Col xs="2" sm="3" lg="2" xl="2" style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                className="icon-bonez"
                                title="Zoombies Bones"
                                alt=""
                                src={bonezIcon}
                            />
                            <span className="container-body-text bone-amount" style={{ marginLeft: "5%" }}>
                                {userLevels && userLevels.bone.toLocaleString()}
                            </span>
                        </Col>
                        <Col xs="3" sm="3" lg="3" style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="xp-container">
                                <img
                                    className="icon-xp"
                                    title="XP"
                                    alt=""
                                    src={xpIcon}
                                />
                                <span className="container-body-text xp-amount" style={{ color: "#FFC350", marginLeft: "5%" }}>
                                    {userLevels && userLevels.xp.toLocaleString()}
                                </span>
                            </div>
                        </Col>
                        <Col xs="auto" sm="2" lg="1" xl="2" style={{ display: 'flex', alignItems: 'center' }}>
                            <span className="container-body-text pot-text" style={{ marginLeft: "-8%" }}>POT</span>
                            {window.Phaser.wagerType === "zoom" ? (
                                <img
                                    className="icon-chipz"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    alt="Chipz icon"
                                />
                            ) : (
                                <img
                                    className="icon-bonez"
                                    title="Zoombies Bones"
                                    alt=""
                                    src={bonezIcon}
                                />
                            )}
                            <span
                                className="container-body-text pot-amount"
                            >
                                {window.Phaser.potAmount.toLocaleString()}
                            </span>
                        </Col>
                        <Col xs="auto" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                            <button
                                ref={settingsButtonRef}
                                className={`settings-button ${isSettingsBarActive ? 'active' : ''}`}
                                onClick={(e) => {
                                    playSound("clickSound");
                                    setIsSettingsBarActive(!isSettingsBarActive);
                                }}
                            >
                                <img
                                    className="image-settings"
                                    title="Settings"
                                    src={settingsIcon}
                                    alt="Settings"
                                />
                            </button>
                        </Col>
                        <Col xs="auto" sm="1" md="1" lg="1" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                            <button
                                ref={infoButtonRef}
                                className="info-button"
                                onClick={(e) => {
                                    playSound("clickSound");
                                    setIsInfoBarActive(!isInfoBarActive);
                                }}
                            >
                                <img
                                    className="image-info"
                                    title="Info"
                                    src={infoIcon}
                                    alt="Info"
                                />
                            </button>
                        </Col>
                        <Col xs="1" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                            <button
                                className="leave-button"
                                onClick={(e) => {
                                    playSound("clickSound");
                                    setShowLeaveGameModal(true);
                                }}
                            >
                                <img
                                    className="image-leave"
                                    title="Leave Game"
                                    src={leaveGameButton}
                                    alt="Leave Game"
                                />
                            </button>
                        </Col>
                    </Row>
                </Container>
                <audio id="clickSound" className="sound-fx" hidden>
                    <source src="/bonez/sounds/click.mp3" type="audio/mp3" />
                </audio>
            </Navbar>

            <Offcanvas show={isSettingsBarActive} onHide={() => setIsSettingsBarActive(false)} placement="end" style={{ backgroundColor: '#1B3A5D' }}>
                <Offcanvas.Header className="offcanvas-header-container" closeButton style={{ justifyContent: 'center' }}>
                    <Offcanvas.Title
                        style={{
                            fontFamily: 'Truculenta, sans-serif',
                            fontSize: '40px',
                            fontWeight: 'bold',
                            color: 'white',
                            marginLeft: '5%',
                            marginBottom: '-5%'
                        }}
                    >
                        Settings
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "5.5%" }}>Music</span>
                        <input
                            className="volume-slider"
                            type="range"
                            min="0"
                            max="100"
                            value={musicVolume}
                            onChange={e => setMusicVolume(e.target.value)}
                            style={musicSliderBackground}
                        />

                        <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "6.5%" }}>Sound FX</span>
                        <input
                            className="volume-slider"
                            type="range"
                            min="0"
                            max="100"
                            value={soundVolume}
                            onChange={e => setSoundVolume(e.target.value)}
                            style={soundSliderBackground}
                        />
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            <InfoNav
                isInfoBarActive={isInfoBarActive}
                setIsInfoBarActive={setIsInfoBarActive}
            />

            <Offcanvas
                show={isPlayerInfonav}
                onHide={() => {
                    setIsPlayerInfonav(false);
                    window.Phaser.PlayerInfo = false;
                    window.Phaser.MyInfo = false;
                    window.Phaser.SpectatorInfo = false;
                    window.Phaser.SpectatorId = null;
                }}
                placement="end"
            >

                <Offcanvas.Body
                    className="canvasshop"
                    style={{
                        backgroundColor: ' #000022',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '400px',
                        height: 'auto',
                    }}
                >
                    <PlayerInfo gameData={gameData} isSpectator={isSpectator} />
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas show={playerChatOpen} placement="end" onHide={() => setPlayerChatOpen(false)}>
                <Offcanvas.Body style={{ backgroundColor: '#001f3f', alignItems: 'center', justifyContent: 'center' }}>
                    <PlayerChat
                        gameData={gameData}
                        isSpectator={isSpectator}
                        playerChatOpen={playerChatOpen}
                        togglePlayerChat={togglePlayerChat}
                    />
                </Offcanvas.Body>
            </Offcanvas>

            {!isSpectator && gameData && gameData.playerPowerCardsPlayed && //RESURRECT MODAL
                <Modal show={displayResurrectModal.value} onHide={() => displayResurrectModal.value = false} centered>
                    <div className="whole-container">
                        <h1 className="container-title" style={{ color: "#BD00FF" }}>{gameData.playerPowerCardsPlayed.length > 0 ? "Choose a card to resurrect!" : "No cards to resurrect"}</h1>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            {gameData.playerPowerCardsPlayed.map((card, index) => {
                                return <div key={index} style={{ marginLeft: "4%", marginRight: "4%", marginBottom: "2%", marginTop: "2%" }}>
                                    <button className="button" style={{ width: "100%", height: "100%" }} onClick={async () => {
                                        //button script
                                        if (card.cardName !== "steal") {
                                            if (socketConnected && matchId !== "") {
                                                const data = {
                                                    name: "resurrect",
                                                    option: { resurrectIndex: index, resurrectOption: "" },
                                                    cardIndex: displayResurrectModal.cardIndex
                                                }

                                                try {
                                                    await socket.sendMatchState(matchId, opCodes.playerPlayPowerCard, JSON.stringify(data));
                                                    console.log("resurrect power card play requested: ", data);
                                                } catch (err) {
                                                    console.log("Error playing power card: ", err);
                                                }
                                            }
                                        }
                                        else if (card.cardName === "steal" && gameRef && gameRef.scene && gameRef.scene.scenes[1]) {
                                            //update stealSelected to active card click listeners in Phaser
                                            // gameRef.scene.scenes[1].setStealSelected(true, true, index);
                                            gameRef.scene.scenes[1].playerCard1.resurrectSteal(index, displayResurrectModal.cardIndex);
                                        }

                                        displayResurrectModal.value = false;
                                    }}>
                                        <img
                                            src={cardImages(`./power-cards/${card.cardName}.svg`)}
                                            alt=""
                                            style={{ width: 239 * 0.5 + "px", height: 315 * 0.5 + "px" }}
                                        />
                                        <img
                                            src={card.cardOption === "plus" ? cardImages(`./plus_icon.svg`) : (card.cardOption === "neg" ? cardImages(`./minus_icon.svg`) : (card.cardOption === "one" ? cardImages(`./one_icon.svg`) : (card.cardOption === "eleven" ? cardImages(`./eleven_icon.svg`) : "")))}
                                            style={{ width: 32 + "px", height: "auto", position: "absolute", top: -10 + "px", right: 14 + "px" }}
                                        />
                                    </button>
                                </div>
                            })}
                        </div>
                        <h1 className="container-body-text" style={{ color: "#00D1FF", marginBottom: "5%" }}>{gameData.playerPowerCardsPlayed.length > 0 ? "Remember, the card you choose will be played immediately" : "Play a power card to resurrect it!"}</h1>
                        <button className="button" style={{ display: 'block' }} onClick={() => displayResurrectModal.value = false}>
                            <img
                                src="https://zoombies.world/images/dapp/pink_button_400.webp"
                                alt=""
                                style={{ width: "100%", height: "100%" }}
                            />
                            <span
                                className="button-text"
                                style={{ color: "#000000" }}
                            >
                                Cancel
                            </span>
                        </button>

                    </div>
                </Modal>
            }




            <div>
                <Modal show={showLeaveGameModal} centered>
                    <LeaveGameModal matchId={matchId} onCloseModal={closeModal} gameRef={gameRef} />
                </Modal>
            </div>
            {gameData && //WINNER MODAL
                <Modal show={showWinModal} centered>
                    <div className="whole-container" style={{ width: "150%", marginLeft: "-23%" }}>
                        <div className="row">
                            <div className="offset-lg-1 offset-sm-1 col-sm-4 col-lg-4 d-flex justify-content-center" >
                                <div style={{ textAlign: "center" }}>
                                    <img src={win_trophy} alt="" style={{ position: "absolute", width: "50%", marginTop: "10%", marginLeft: "-25%" }} />
                                    <img src={gameData.player.avatarUrl} style={{ borderRadius: "50px", position: "absolute", marginLeft: "-10%", marginTop: "-12%" }} alt="" />
                                    <h1 className="container-subtitle light-blue-text" style={{ fontSize: "25px", marginTop: "50px" }}>{gameData.player.username.substring(0, 14)} </h1>
                                    <h1 className="container-subtitle pink-text" style={{ fontSize: "55px" }}>WINNER!</h1>
                                    <h1 className="container-subtitle orange-text" style={{ fontSize: "25px", color: playerWinStreak > 0 ? "#FF7A00" : "transparent", display: "inline-block", margin: 0 }}>{playerWinStreak}</h1>
                                    {
                                        playerWinStreak > 0 &&
                                        <img src={fire_icon} alt="" style={{ display: "inline", marginRight: "2%", width: "25px", verticalAlign: "middle", marginLeft: "5px", marginTop: "-8px" }} />
                                    }
                                    <h1 className="container-subtitle orange-text" style={{ fontSize: "25px", color: playerWinStreak > 0 ? "#FF7A00" : "transparent", display: "inline-block", margin: 0 }}>WIN STREAK!</h1>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        {gameData.matchInfo.wagerType === "zoom" ? (
                                            <>
                                                <img
                                                    className="chipz-icon"
                                                    style={{ display: 'inline', marginRight: '0.2rem' }}
                                                    title="Zoombies Chipz"
                                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                                    alt="Chipz icon"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <img src={bonezIcon} alt="" style={{ display: "inline", marginRight: "2%" }} />
                                            </>
                                        )}
                                        < span style={{ display: "inline", fontSize: "30px" }} className="container-body-text" >{(gameData.matchInfo.potAmount - gameData.matchInfo.tableFee).toLocaleString()} </span>
                                    </div>
                                    <h1 className="container-subtitle pink-text" style={{ fontSize: "25px", fontWeight: "bold" }}>XP EARNED 12</h1>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-2 d-flex justify-content-center align-items-center flex-column">
                                <h1 className="container-title gray-text" style={{ marginTop: "-75px", fontSize: "60px", fontWeight: "bold" }}>VS</h1>
                                <h1 className="container-title gray-text" style={{ marginTop: "75px", fontSize: "35px", fontWeight: "bold", wordBreak: "none" }}>GAME&nbsp;OVER</h1>
                            </div>
                            <div className="col-lg-4 col-sm-4 d-flex justify-content-center">
                                <div style={{ textAlign: "center" }}>
                                    <img src={lose_icon} alt="" style={{ position: "absolute", width: "50%", marginTop: "10%", marginLeft: "-25%" }} />
                                    <img src={gameData.opponent.avatarUrl} style={{ position: "absolute", borderRadius: "50px", marginLeft: "-10%", marginTop: "-12%" }} alt="" />
                                    <h1 className="container-subtitle light-blue-text" style={{ fontSize: "25px", marginTop: "50px" }}>{gameData.opponent.username.substring(0, 14)} </h1>
                                    <h1 className="container-subtitle red-text" style={{ fontSize: "55px" }}>LOSER</h1>
                                    <h1 className="container-subtitle orange-text" style={{ fontSize: "25px", color: "transparent" }}>LOSE STREAK!</h1>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        {gameData.matchInfo.wagerType === "zoom" ? (
                                            <>
                                                <img
                                                    className="chipz-icon stat-icon"
                                                    title="Zoombies Chipz"
                                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                                    alt="Chipz icon"
                                                />{' '}
                                            </>
                                        ) : (
                                            <>
                                                <img src={bonezIcon} alt="" style={{ display: "inline", marginRight: "2%" }} />
                                            </>
                                        )}
                                        <span style={{ display: "inline", fontSize: "30px" }} className="container-body-text" >0</span>
                                    </div>
                                    <h1 className="container-subtitle pink-text" style={{ fontSize: "25px", fontWeight: "bold" }}>XP EARNED 2</h1>
                                </div>
                            </div>
                        </div>
                        <button className="button" style={{ position: "absolute", marginLeft: "55%", display: 'block', width: "35%", height: "15%" }} onClick={() => { gameData = null; setOpCodeData(null); setShowWinModal(false); clearTimeout(timeoutRef.current); setCurrentScreen("lobby") }}>
                            <img
                                src="https://zoombies.world/images/dapp/green_button_400.webp"
                                alt=""
                                style={{ width: "100%", height: "100%" }}
                            />
                            <h1
                                className="button-text"
                                style={{ color: "#000000", textTransform: "none", fontWeight: "1500px", margin: "auto" }}
                            >
                                Return to Lobby
                            </h1>
                        </button>
                    </div>
                </Modal>
            }

            {
                gameData && //LOSER MODAL 
                <Modal show={showLoseModal} centered>
                    {/* <audio id="clickSound" class="sound-fx" hidden>
                        <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
                        Your browser does not support the audio element.
                    </audio> */}
                    <div className="whole-container lose-modal" style={{ width: "150%", marginLeft: "-23%" }}>
                        <div className="row">
                            <div className="col-lg-5 col-sm-4 d-flex justify-content-center">
                                <div className="winner-side" style={{ textAlign: "center" }}>
                                    <img src={win_trophy} alt="" style={{ position: "absolute", width: "50%", marginTop: "10%", marginLeft: "-25%" }} />
                                    <img src={gameData.opponent.avatarUrl} style={{ borderRadius: "50px", position: "absolute", marginLeft: "-10%", marginTop: "-8%" }} alt="" />
                                    <h1 className="container-subtitle light-blue-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "40px", marginTop: "45px" }}>{gameData.opponent.username.substring(0, 14)} </h1>
                                    <h1 className="container-subtitle pink-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "55px" }}>WINNER!</h1>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {gameData.matchInfo.wagerType === "zoom" ? (
                                            <>
                                                <img
                                                    className="chipz-icon stat-icon"
                                                    title="Zoombies Chipz"
                                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                                    alt="Chipz icon"
                                                    style={{ marginRight: "2%", position: "relative", top: "-5px", left: "-10%" }}
                                                />{' '}
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    src={bonezIcon}
                                                    alt=""
                                                    style={{ display: "inline", marginRight: "7%", top: "-5px", position: "relative", left: "-5px" }}
                                                />
                                            </>
                                        )}
                                        <span style={{ display: "inline", fontFamily: 'TruculentaBold, sans-serif', fontSize: "30px", position: "relative", left: "-5%", top: "-5px" }} className="container-body-text">
                                            {(gameData.matchInfo.potAmount - gameData.matchInfo.tableFee).toLocaleString()}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <img src={xpIcon} alt="" style={{ display: "inline", marginRight: "5%", width: "25px", verticalAlign: "middle", marginBottom: "8px" }} />
                                        <h1 className="container-subtitle pink-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "25px", color: "#FFC350", fontWeight: "bold" }}>+ 12</h1>
                                    </div>
                                    <h1 className="container-subtitle orange-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "25px", color: opponentWinStreak > 0 ? "#FF7A00" : "transparent", display: "inline-block", margin: 0 }}>{opponentWinStreak}</h1>
                                    {
                                        opponentWinStreak > 0 &&
                                        <img src={fire_icon} alt="" style={{ display: "inline", marginRight: "2%", width: "25px", verticalAlign: "middle", marginLeft: "5px", marginTop: "-8px" }} />
                                    }
                                    <h1 className="container-subtitle orange-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "25px", color: opponentWinStreak > 0 ? "#FF7A00" : "transparent", display: "inline-block", margin: 0 }}>WIN STREAK!</h1>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-2 d-flex justify-content-center align-items-center flex-column">
                                <h1 className="container-title gray-text" style={{ marginTop: "-75px", fontSize: "60px", fontWeight: "bold" }}>VS</h1>
                                <h1 className="container-title gray-text" style={{ marginTop: "75px", fontSize: "35px", fontWeight: "bold", wordBreak: "none" }}>GAME&nbsp;OVER</h1>
                            </div>
                            <div className="offset-lg-1 offset-sm-1 col-sm-4 col-lg-4 d-flex justify-content-center" >
                                <div className="loser-side" style={{ textAlign: "center" }}>
                                    <img src={lose_icon} alt="" style={{ position: "absolute", width: "50%", marginTop: "10%", marginLeft: "-26%" }} />
                                    <img src={gameData.player.avatarUrl} style={{ position: "absolute", borderRadius: "50px", marginLeft: "-10%", marginTop: "-8%" }} alt="" />
                                    <h1 className="container-subtitle light-blue-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "40px", marginTop: "45px" }}>{gameData.player.username.substring(0, 14)} </h1>
                                    <h1 className="container-subtitle red-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "55px" }}>LOSER</h1>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {gameData.matchInfo.wagerType === "zoom" ? (
                                            <img
                                                className="chipz-icon stat-icon"
                                                title="Zoombies Chipz"
                                                src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                                alt="Chipz icon"
                                                style={{ marginRight: "2%", position: "relative", top: "-5px", left: "-20%" }}
                                            />
                                        ) : (
                                            <img
                                                src={bonezIcon}
                                                alt=""
                                                style={{ display: "inline", marginRight: "7%", top: "-5px", position: "relative", left: "-5px" }} />
                                        )}
                                        <span style={{ display: "inline", fontFamily: 'TruculentaBold, sans-serif', fontSize: "30px", position: "relative", left: "-5%", top: "-5px" }} className="container-body-text">0 </span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <img src={xpIcon} alt="" style={{ display: "inline", marginRight: "5%", width: "25px", verticalAlign: "middle", marginBottom: "8px" }} />
                                        <h1 className="container-subtitle pink-text" style={{ fontFamily: 'TruculentaBold, sans-serif', fontSize: "25px", color: "#FFC350", fontWeight: "bold" }}>+ 2</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="button" style={{ position: "absolute", bottom: "-9%", marginLeft: "55%", display: 'block', width: "35%", height: "15%" }} onClick={() => { gameData = null; setOpCodeData(null); setShowWinModal(false); clearTimeout(timeoutRef.current); setCurrentScreen("lobby") }}>
                            <img
                                src="https://zoombies.world/images/dapp/green_button_400.webp"
                                alt=""
                                style={{ width: "100%", height: "100%" }}
                            />
                            <h1
                                className="button-text"
                                style={{ color: "#000000", fontSize: "23px", textTransform: "none", fontWeight: "1500px", margin: "auto" }}
                            >
                                Return to Lobby
                            </h1>
                        </button>
                    </div>
                </Modal>
            }

            {
                gameData &&
                <Modal
                    show={showTieModal}
                    onHide={() => { setShowTieModal(false) }}
                    centered
                    style={{ backgroundColor: 'transparent' }}
                    contentClassName="transparent-modal-content"
                >
                    <div style={{ position: "relative", display: "flex", flexDirection: 'column', alignItems: "center", justifyContent: "center", background: 'transparent' }}>
                        <img
                            className="icon"
                            title="Round Tie"
                            src={tieBackground}
                            style={{ width: "100%" }}
                            alt="Round Tie Background"
                        />
                        <div className="text-wrapper" style={{ position: "absolute" }}>
                            <div className="text-pair-1">
                                <span
                                    className="container-body-text text-background"
                                >
                                    ROUND
                                </span>
                                <span
                                    className="container-body-text text-foreground"
                                >
                                    ROUND
                                </span>
                            </div>
                            <div className="text-pair-2">
                                <span
                                    className="container-body-text text-background"
                                >
                                    TIED!
                                </span>
                                <span
                                    className="container-body-text text-foreground"
                                >
                                    TIED!
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {
                gameData && //DISCONNECT TIMER MODAL
                <Modal show={showDisconnectModal} centered>
                    <div className="whole-container">
                        <h1 className="container-subtitle" style={{ color: "#00D1FF" }}>{gameData.opponent.username} has disconnected</h1>
                        <h1 style={{ display: "inline" }} className="container-body-text">Time remaining for player to re-join:</h1>
                        <h1 className="container-title" style={{ color: "#00D1FF" }}>{new Date(disconnectTimer * 1000).toISOString().substring(14, 19)}</h1>
                    </div>
                </Modal>
            }

            {
                gameData && //DISCONNECT TIMER MODAL FOR SPECTATORS
                <Modal show={showDisconnectModalSpectator} centered>
                    <div className="whole-container">
                        <h1 className="container-subtitle" style={{ color: "#00D1FF" }}>A player has disconnected</h1>
                        <h1 style={{ display: "inline" }} className="container-body-text">Time remaining for player to re-join:</h1>
                        <h1 className="container-title" style={{ color: "#00D1FF" }}>{new Date(disconnectTimer * 1000).toISOString().substring(14, 19)}</h1>
                    </div>
                </Modal>
            }

            <ToastContainer
                position={'top-end'}
                style={{ zIndex: 9999, marginTop: '70px' }}
            >
                {/* Bone Collection Toast - Playful Friend Theme */}
                <Toast
                    onClose={() => setShowToast(false)}
                    show={showToast}
                    delay={4000}
                    autohide
                    style={{
                        minWidth: '350px',
                        background: 'linear-gradient(135deg, #20c997 0%, #17a2b8 100%)',
                        border: '2px solid #17a2b8',
                        boxShadow: '0 6px 20px rgba(23, 162, 184, 0.3)',
                        borderRadius: '12px'
                    }}
                >
                    <Toast.Header style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #17a2b8',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '20px', marginRight: '8px' }}>👥</span>
                        <strong className="me-auto" style={{ fontSize: '16px', color: '#17a2b8' }}>Friend Activity</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '16px',
                        color: '#fff',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'center'
                    }}>
                        <div style={{ fontSize: '32px', marginBottom: '4px' }}>🦴</div>
                        <div>Bone COLLECTED by <strong>{username}</strong>!</div>
                    </Toast.Body>
                </Toast>

                {/* Tournament Toast - Gold Celebration Theme */}
                <Toast
                    show={showTournamentToast}
                    onClose={() => setShowTournamentToast(false)}
                    delay={6000}
                    autohide
                    style={{
                        minWidth: '350px',
                        background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                        border: '3px solid #FFD700',
                        boxShadow: '0 8px 24px rgba(255, 215, 0, 0.4), 0 0 20px rgba(255, 215, 0, 0.3)',
                        borderRadius: '12px'
                    }}
                >
                    <Toast.Header style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #FFD700',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '24px', marginRight: '8px' }}>🏆</span>
                        <strong className="me-auto" style={{ fontSize: '18px', color: '#B8860B' }}>Tournament Ended!</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '20px',
                        color: '#000',
                        fontSize: '16px',
                        fontWeight: '600',
                        textAlign: 'center',
                        textShadow: '1px 1px 2px rgba(255,255,255,0.8)'
                    }}>
                        <div style={{ fontSize: '20px', marginBottom: '8px' }}>🎉 {tournamentEndedText} 🎉</div>
                    </Toast.Body>
                </Toast>

                {/* Match Result Toast - Victory Celebration Theme */}
                <Toast
                    onClose={() => setShowMatchResultToast(false)}
                    show={showMatchResultToast}
                    delay={5000}
                    autohide
                    className="match-result-toast"
                >
                    <Toast.Header closeButton={true} style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #28a745',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '20px', marginRight: '8px' }}>🎮</span>
                        <strong className="me-auto" style={{ fontSize: '16px', color: '#28a745' }}>Match Result</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '20px',
                        color: '#fff',
                        textAlign: 'center'
                    }}>
                        {typeof matchResultText === 'object' ? (
                            <>
                                <div style={{ fontSize: '20px', marginBottom: '8px', fontWeight: '600', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
                                    {matchResultText.subject}
                                </div>
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: 'bold',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                    marginBottom: '8px'
                                }}>
                                    {parseInt(matchResultText.potWin).toLocaleString()}{' '}
                                    {matchResultText.isChipz ? (
                                        <img
                                            src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                            style={{ width: '24px', height: '24px', verticalAlign: 'middle' }}
                                            alt="chipz"
                                        />
                                    ) : (
                                        '🦴'
                                    )}
                                </div>
                                <div style={{ fontSize: '24px' }}>🎉</div>
                            </>
                        ) : (
                            matchResultText
                        )}
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            <GamePhaser setGameRef={setGameRef} />
        </div>
    )

};